
<template>
  <div class="empty-state">
    <img src="../../../../../../assets/images/empty_icon.png" alt="" class="empty-img" />
    <p class="empty-desc">{{ $t("FoodC_C_No_suitable_UnyN") }}</p>
    <div class="go-home" @click="goHome">{{$t('FoodC_C_Back_Home_opQY')}}</div>
  </div>
</template>

<script>
import {
  getScheme
} from '@/common/js/utils'
export default {
  name: 'EmptyState',
  methods: {
    goHome () {
      location.href = `${getScheme()}://soda/homePage?closeSideMenu=1`
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/var.scss";

.empty-state {
  padding-top: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .empty-img {
    width: 312px;
    height: 312px;
    margin-bottom: 56px;
  }
  .empty-desc {
    padding: 0 40px;
    font-family: "Aspira Medium";
    font-size: 44px;
    color: #000000;
    text-align: center;
    font-weight: 500;
    text-align: center;
    margin-bottom: 40px;
  }
  .go-home {
    height: 60px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Aspira Regular";
    font-size: 28px;
    font-weight: 400;
    padding: 0 24px;
    @include rich-dialog-btn-color();
    @include rich-dialog-btn-border-color();
  }
  .go-home:active {
    @include rich-dialog-btn-active-bg();
  }
}
</style>
